__webpack_require__.p = "/event-reminders/referrals-hub/";